export default __webpack_public_path__ + "warning.5c43866e.svg";